import Env from '../base/env'
import Player from '@vimeo/player';

export default class PlayerVimeo
{
  constructor(view)
  {
    this.view = view
    this.$trigger = this.view.querySelector('.jsTrigger')
    this.$poster = this.view.querySelector('.jsPoster')
    // Popin
    this.$popin = document.querySelector('.jsPopin-video')
    this.$popinReceptor = this.$popin.querySelector('.jsReceptor')
    this.$close = this.$popin.querySelector('.jsClose')
    // Flags
    this.IS_CREATED = false
  }

  createPlayer()
  {
    const options = {
      transparent : 0,
      url: this.view.getAttribute('data-video'),
      responsive: true,
      muted:false,
      autoplay: false
    }
    this.player = new Player(this.$popinReceptor, options);
    setTimeout(() => {
      this.player.on('play', ()=> {
        console.log('is playing 3');
      });
      this.player.getVideoTitle().then((title)=> {
          console.info('ready:', title);
      });
    }, 1500);
    this.IS_CREATED = true
  }

  events()
  {
    this.$trigger.addEventListener('click',()=>{
      if(this.IS_CREATED == false) {
        this.createPlayer()
      }
      Env.$html.classList.add('video--isPlaying')
      this.player.play()
      this.player.setMuted(false)

    })

    this.$close.addEventListener('click',()=>{
      this.IS_CREATED = false
      Env.$html.classList.remove('video--isPlaying')
      this.player.destroy()
      this.$popinReceptor.innerHTML = ''
    })
  }

  setup()
  {
    this.events()
  }
}
